/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscriptionalertpurchasefailedmessage4Inputs */



/**
* | output |
* | --- |
* | "We couldn't complete the purchase. Please try again a bit later." |
*
* @param {Subscriptionalertpurchasefailedmessage4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscriptionalertpurchasefailedmessage4 = /** @type {((inputs?: Subscriptionalertpurchasefailedmessage4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscriptionalertpurchasefailedmessage4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("We couldn't complete the purchase. Please try again a bit later.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo completar la compra. Inténtalo de nuevo un poco más tarde.")
	return /** @type {LocalizedString} */ ("Не удалось завершить покупку. Попробуйте ещё раз чуть позже.")
});
export { subscriptionalertpurchasefailedmessage4 as "subscriptionAlertPurchaseFailedMessage" }